import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, Package, ShoppingCart, BookOpen, ClipboardList, LogOut, LineChart } from "lucide-react";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (!user || !["staff","manager","owner"].includes(user.role)) nav("/login");
  }, [user, loading, nav]);

  const link = ({ isActive }) =>
    `flex items-center gap-3 px-6 py-3 text-[11px] tracking-widest-plus uppercase transition-colors ${isActive ? "bg-gold text-ink" : "text-ivory/70 hover:text-gold"}`;

  return (
    <div className="min-h-screen section-dark">
      <div className="flex">
        <aside className="w-64 border-r border-ivory/10 min-h-screen sticky top-0">
          <div className="p-8 border-b border-ivory/10">
            <img src={`${process.env.REACT_APP_BACKEND_URL}/api/static/brand/looxs-wordmark.png`} alt="LOOXS" style={{ height: 36, width: "auto", display: "block" }} draggable="false" />
            <p className="text-[9px] tracking-luxury uppercase text-gold mt-2">The Concierge</p>
          </div>
          <nav className="py-4">
            <NavLink data-testid="admin-nav-dashboard" to="/admin" end className={link}><LayoutDashboard className="w-4 h-4" strokeWidth={1.25} /> Overview</NavLink>
            <NavLink data-testid="admin-nav-products" to="/admin/products" className={link}><Package className="w-4 h-4" strokeWidth={1.25} /> Products</NavLink>
            <NavLink data-testid="admin-nav-chapters" to="/admin/chapters" className={link}><BookOpen className="w-4 h-4" strokeWidth={1.25} /> Chapters</NavLink>
            <NavLink data-testid="admin-nav-orders" to="/admin/orders" className={link}><ShoppingCart className="w-4 h-4" strokeWidth={1.25} /> Orders</NavLink>
            <NavLink data-testid="admin-nav-preorders" to="/admin/preorders" className={link}><ClipboardList className="w-4 h-4" strokeWidth={1.25} /> Pre-orders</NavLink>
            <NavLink data-testid="admin-nav-insights" to="/admin/insights" className={link}><LineChart className="w-4 h-4" strokeWidth={1.25} /> Insights</NavLink>
            <NavLink data-testid="admin-nav-cms" to="/admin/cms" className={link}><BookOpen className="w-4 h-4" strokeWidth={1.25} /> CMS</NavLink>
          </nav>
          <button onClick={() => { logout(); nav("/"); }} className="flex items-center gap-3 px-6 py-3 text-[11px] tracking-widest-plus uppercase text-ivory/50 hover:text-gold mt-8">
            <LogOut className="w-4 h-4" strokeWidth={1.25} /> Sign out
          </button>
        </aside>
        <main className="flex-1 p-10 md:p-16 text-ivory">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
